import { z } from 'zod';

import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { FormField } from './constants';
import { FormValues } from './types';

export const formValidationSchema = z.object({
  [FormField.comment]: z
    .string({ error: REQUIRED_VALIDATION_MESSAGE })
    .trim()
    .nonempty({ error: REQUIRED_VALIDATION_MESSAGE })
    .max(500),
}) satisfies z.ZodType<FormValues>;
